import {
  createBrowserRouter,
  RouteObject,
  RouterProvider,
} from "react-router-dom";

import { IgErrorBoundary } from "@src/components/Utils/IgErrorBoundary";
import MobileLoggedInProvider from "@src/features/mobileAnalytics/shared/providers/MobileLoggedInProvider";
import { AdminNoPaddingPageProvider } from "@src/providers/AdminNoPaddingPageProvider";
import { AdminPageProvider } from "@src/providers/AdminPageProvider";
import { AiPageProvider } from "@src/providers/AiPageProvider";
import { FullPageProvider } from "@src/providers/FullPageProvider";
import { KnowledgePageProvider } from "@src/providers/KnowledgePageProvider";
import { LoggedInProvider } from "@src/providers/LoggedInProvider";
import { SettingsPageProvider } from "@src/providers/SettingsPageProvider";
import { StandardNoPaddingPageProvider } from "@src/providers/StandardNoPaddingPageProvider";
import { StandardPageProvider } from "@src/providers/StandardPageProvider";
import { AdminPageRoutes } from "@src/routes/loggedIn/adminPageRoutes";
import { AdminNoPaddingRoutes } from "@src/routes/loggedIn/adminPageRoutes/adminNoPaddingRoutes";
import { AiPageRoutes } from "@src/routes/loggedIn/aiPageRoutes";
import { KnowledgeRoutes } from "@src/routes/loggedIn/knowledgeRoutes";
import { StandardNoPaddingRoutes } from "@src/routes/loggedIn/standardNoPaddingRoutes";
import { SettingsRoute } from "@src/routes/loggedIn/standardPageRoutes/settingsRoute";
import { MobileRoutes } from "@src/routes/mobile";
import { PublicPageRoutes } from "@src/routes/public/public-page-routes";
import { shouldShowMobileExperience } from "@src/utils/deviceDetection";

import { FullPageRoutes } from "./fullPageRoutes";
import { StandardPageRoutes } from "./standardPageRoutes";
import { OnboardingPageProvider } from "@src/providers/OnboardingPageProvider";
import { OnboardingPageRoutes } from "@src/routes/loggedIn/onboardingPageRoutes/onboardingPageRoutes";

const desktopRoutes: RouteObject[] = [
  {
    errorElement: <IgErrorBoundary />,
    element: <LoggedInProvider />,
    children: [
      {
        element: <KnowledgePageProvider />,
        children: KnowledgeRoutes,
      },
      {
        element: <AdminPageProvider />,
        children: AdminPageRoutes,
      },
      {
        element: <AiPageProvider />,
        children: AiPageRoutes,
      },
      {
        element: <AdminNoPaddingPageProvider />,
        children: AdminNoPaddingRoutes,
      },
      {
        element: <OnboardingPageProvider />,
        children: OnboardingPageRoutes,
      },
      {
        element: <StandardPageProvider />,
        children: StandardPageRoutes,
      },
      {
        element: <FullPageProvider />,
        children: FullPageRoutes,
      },
      {
        element: <StandardNoPaddingPageProvider />,
        children: StandardNoPaddingRoutes,
      },
      {
        element: <SettingsPageProvider />,
        children: SettingsRoute,
      },
      ...PublicPageRoutes,
    ],
  },
];
const desktopRouter = createBrowserRouter(desktopRoutes);

const mobileRoutesConfig: RouteObject[] = [
  {
    element: <MobileLoggedInProvider />,
    children: MobileRoutes,
  },
];
const mobileRouter = createBrowserRouter(mobileRoutesConfig);

export const SubscribedRoutes = () => {
  const showMobileExperience = shouldShowMobileExperience();

  return showMobileExperience ? <MobileApp /> : <DesktopApp />;
};

function DesktopApp() {
  return <RouterProvider router={desktopRouter} />;
}

function MobileApp() {
  return <RouterProvider router={mobileRouter} />;
}
